<template>
  <div>
    <v-skeleton-loader
      v-if="dataLoading"
      class="mx-auto"
      type="table"
    ></v-skeleton-loader>
    <v-data-table
      v-if="!dataLoading"
      :headers="headers"
      :items="users"
      :sort-by="['UserLastModifiedDate', 'username']"
      :sort-desc="[true, false]"
      :search="search"
      style="cursor: pointer"
      @click:row="onUserRowClicked"
      mobile-breakpoint="0"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <template>
            <v-btn elevation="0"
              v-if="!adminview"
              small
              color="success"
              dark
              class="mb-2"
              @click="showCreateDialog = true"
            >
              <v-icon small dense class="mr-2"
                >mdi-account-plus</v-icon
              >Create User
            </v-btn>
            <v-btn elevation="0"
              small
              color="success"
              dark
              class="mb-2"
              style="margin-left: 5px"
              @click="refreshCognitoUsers"
            >
              <v-icon small dense>mdi-refresh</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              small
              dense
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              hint="Search on user name or email etc"
            ></v-text-field>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:[`item.Enabled`]="{ item }">
        <v-chip :color="item.Enabled ? 'green' : 'grey'" small label outlined>
          <v-avatar left>
            <v-icon small>{{
              item.Enabled ? "mdi-check-circle-outline" : "mdi-minus-circle"
            }}</v-icon>
          </v-avatar>
          {{ item.Enabled ? "Enabled" : "Disabled" }}
        </v-chip>
      </template>
      <template v-slot:[`item.email`]="{ item }">
        {{ item.email || "-" }}
      </template>
      <template v-slot:[`item.email_verified`]="{ item }">
        {{ item.email_verified ? "Yes" : "No" }}
      </template>
      <template v-slot:[`item.UserStatus`]="{ item }">
        <v-chip
          dense
          small
          :color="item.UserStatus == 'CONFIRMED' ? 'green' : '#0073bb'"
          label
          text-color="white"
        >
          {{ item.UserStatus }}
        </v-chip>
      </template>
      <template v-slot:[`item.custom:venue`]="{ item }">
        {{ item[`custom:venue`] || "-" }}
      </template>
      <template v-slot:[`item.custom:admin`]="{ item }">
        {{ item[`custom:admin`] ? "Admin" : "End User" }}
      </template>
    </v-data-table>
    <v-dialog v-model="showEditDialog" max-width="700px" persistent>
      <v-card>
        <v-toolbar color="#425058" dark dense >
            <v-toolbar-title>Edit User</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn elevation="0"
              class="cancelButton"
              icon
              small
              @click="showEditDialog = false"
           
              ><v-icon class="white--text">mdi-close</v-icon></v-btn
            >
        </v-toolbar>
        <v-card-text>
          <v-container class="pa-5 mt-5">
            <v-row>
              <v-col>
                <v-row>User Name </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.Username }}
                </v-row>
                <v-row>Email </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.email || "-" }}
                </v-row>
                <v-row>Email Verified </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.email_verified ? "Yes" : "No" }}
                </v-row>
                <v-row>Venue </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj[`custom:venue`] || "-" }}
                </v-row>
                <v-row>Email Verified </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj[`custom:admin`] ? "Admin" : "End User" }}
                </v-row>
              </v-col>
              <v-divider vertical inset class="mx-4"></v-divider>
              <v-col>
                <v-row>Account Status </v-row>
                <v-row class="mb-5 font-weight-black"
                  ><v-chip
                    :color="editUserObj.Enabled ? 'green' : 'grey'"
                    small
                    label
                    outlined
                  >
                    <v-avatar left>
                      <v-icon small>{{
                        editUserObj.Enabled
                          ? "mdi-check-circle-outline"
                          : "mdi-minus-circle"
                      }}</v-icon>
                    </v-avatar>
                    {{ editUserObj.Enabled ? "Enabled" : "Disabled" }}
                  </v-chip>
                </v-row>
                <v-row>Confirmation Status </v-row>
                <v-row class="mb-5 font-weight-black">
                  <v-chip
                    dense
                    small
                    :color="
                      editUserObj.UserStatus == 'CONFIRMED'
                        ? 'green'
                        : '#0073bb'
                    "
                    label
                    text-color="white"
                  >
                    {{ editUserObj.UserStatus }}
                  </v-chip>
                </v-row>
              </v-col>
              <v-divider vertical inset class="mx-4"></v-divider>
              <v-col>
                <v-row>Created Date </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.UserCreateDate }}
                </v-row>
                <v-row>Last Updated Date </v-row>
                <v-row class="mb-5 font-weight-black"
                  >{{ editUserObj.UserLastModifiedDate }}
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions
          class="pb-2"

        >
        <v-spacer></v-spacer>
          <v-btn elevation="0"
            v-if="editUserObj.Enabled"
            small
            color="warning"
            @click="onUserDisable(editUserObj.Username)"
            :disabled="!editUserObj.Enabled"
            >Disable</v-btn
          >
          <v-btn elevation="0"
            v-if="!editUserObj.Enabled"
            small
            color="success"
            @click="onUserEnable(editUserObj.Username)"
            :disabled="editUserObj.Enabled"
            >Enable</v-btn
          >
          <v-btn elevation="0"
            small
            color="error"
            @click="onUserDelete(editUserObj.Username)"
            :disabled="editUserObj.Enabled"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="showCreateDialog"
      v-model="showCreateDialog"
      max-width="700px"
      persistent
    >
      <v-form ref="createUserForm">
        <v-card>
          <v-toolbar color="#425058" dark dense>
            <div class="titleBar-content">
              <v-toolbar-title class="raceResults-title"
                >Create Terminal User</v-toolbar-title
              >
              <v-btn elevation="0"
                class="cancelButton"
                icon
                small
                @click="showCreateDialog = false"
                ><v-icon class="white--text">mdi-close</v-icon></v-btn
              >
            </div>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-text-field
              label="Username"
              class="mt-2"
              outlined
              :rules="userNameRules"
              dense
              v-model="newUserObj.username"
            ></v-text-field>
            <v-text-field
              label="Email"
              class="mt-2"
              :rules="emailRules"
              outlined
              dense
              v-model="newUserObj.email"
            ></v-text-field>
            <v-select
              v-model="newUserObj.venue"
              :items="venues"
              label="Venue"
              outlined
              requird
              :rules="[(v) => !!v || 'Venue is required']"
            ></v-select>
            <v-select
              v-model="newUserObj.admin"
              :items="roleOptions"
              item-text="text"
              item-value="value"
              label="Role"
              outlined
              requird
              :rules="[(v) => v != undefined || 'Role is required']"
            ></v-select>
          </v-card-text>
          <v-card-actions
            class="mt2"
            style="padding-bottom: 26px; padding-top: 26px"
          >
          <v-spacer></v-spacer>
            <v-btn elevation="0"
              small
              color="error"
              @click="showCreateDialog = false"
              >Cancel</v-btn
            >
            <v-btn elevation="0"
              small
              color="success"
              @click="confirmCreateUser"
              >Confirm</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <ConfirmDialog ref="confirm" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import ConfirmDialog from "./common/ConfirmDialog.vue";
export default {
  data() {
    return {
      showCreateDialog: false,
      showEditDialog: false,
      newUserObj: {},
      editUserObj: {},
      dataLoading: false,
      search: "",
      headers: [
        {
          text: "User Name",
          value: "Username",
        },
        {
          text: "Email",
          value: "email",
        },
        {
          text: "Email Verified",
          value: "email_verified",
        },
   
        {
          text: "Confirmation Status",
          value: "UserStatus",
        },
        {
          text: "Status",
          value: "Enabled",
        },

        {
          text: "Created Date",
          value: "UserCreateDate",
        },
        {
          text: "Updated Date",
          value: "UserLastModifiedDate",
        },
      ],
      roleOptions: [
        { text: "End User", value: 0 },
        { text: "Admin", value: 1 },
      ],
      userNameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
        (v) => (v && v.length >= 6) || "Name must be more than 6 characters",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
    };
  },
   props: {
    //true for display in terminal side, less functionalities
    adminview: {
        type:Boolean,
        default:false
    },
    venuegroup:{
        type: String,
        required: true
    }
  },
  async created() {
    await this.refreshCognitoUsers();
  },
  watch: {
    showCreateDialog(newVal) {
      if (!newVal) this.newUserObj = {};
    },
    showEditDialog(newVal) {
      if (!newVal) this.editUserObj = {};
    },
  },
  computed: {
    ...mapGetters("terminalStore", ["getUsers"]),
    users() {
      return this.getUsers.filter(u=>!u[`custom:admin`]);
    },
  },
  components: {
    ConfirmDialog,
  },
  methods: {
    ...mapActions("terminalStore", [
      "fetchCognitoUsersByGroup",
      "createUser",
      "DisableUser",
      "DeleteUser",
      "EnableUser"
    ]),
    async confirmCreateUser() {
      if (this.$refs.createUserForm.validate()) {
        await this.createUser(this.newUserObj);
        this.showCreateDialog = false;
        await this.refreshCognitoUsers();
      }
    },

    async refreshCognitoUsers() {
      this.dataLoading = true;
      await this.fetchCognitoUsersByGroup(this.venuegroup);
      this.dataLoading = false;
    },

    onUserRowClicked(rowData) {
      this.showEditDialog = true;
      this.editUserObj = rowData;
    },
    async onUserDisable(userName) {
      if (
        await this.$refs.confirm.open(
          `Disable user access for "${userName}"`,
          "This will disable this user's access to the terminal. They will be unable to sign in to the terminal. The user will not be deleted. You can restore the access by enabling this user again",
          { confirmText: "Disable" ,confirmColor:'warning'}
        )
      ) {
        this.showEditDialog = false;
        await this.DisableUser(userName);
        await this.refreshCognitoUsers();
        
      }
    },
    async onUserDelete(userName) {
      if (
        await this.$refs.confirm.open(
          `Delete user "${userName}"`,
          "This will delete this user from the user pool. They will be permanently removed and will no longer be able to sign in",
          {confirmText:'Delete',confirmColor:'error'}
        )
      ) {
        this.showEditDialog = false;
        await this.DeleteUser(userName);
        await this.refreshCognitoUsers();
        
      }
    },
    async onUserEnable(userName) {
      if (
        await this.$refs.confirm.open(
          `Enable user access for "${userName}"`,
          "This will enable this user's access to the terminal. They will be able to sign in to the terminal.",
          {confirmText:'Enable',confirmColor:'success'}
        )
      ) {
        this.showEditDialog = false;
        await this.EnableUser(userName);
        await this.refreshCognitoUsers();
        
      }
    }
  },
};
</script>
